import { communitySchema } from "../../../../lib/types/schema/community/communitySchema";
import { request } from "../../../../request/request";

export const requestCommunitiesAdminCommunityProps = {
  schema: communitySchema,
};

export type RequestCommunitiesAdminCommunityProps = {
  id: number;
};

export const requestCommunitiesAdminCommunity = ({ id, ...props }) =>
  request({
    ...props,
    urlBackendPath: `/communities/${id}`,
    ...requestCommunitiesAdminCommunityProps,
  });
